/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Item_Not_FoundInputs */

const en_us2_plan_item_not_found = /** @type {(inputs: Plan_Item_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not find that exercise in your plan.`)
};

const pt_br2_plan_item_not_found = /** @type {(inputs: Plan_Item_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não encontramos esse exercício no seu plano.`)
};

const es_419_plan_item_not_found = /** @type {(inputs: Plan_Item_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No encontramos ese ejercicio en tu plan.`)
};

const pt_pt2_plan_item_not_found = /** @type {(inputs: Plan_Item_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não encontrámos esse exercício no teu plano.`)
};

const fr_fr2_plan_item_not_found = /** @type {(inputs: Plan_Item_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de trouver cet exercice dans ton programme.`)
};

const de_de2_plan_item_not_found = /** @type {(inputs: Plan_Item_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir haben diese Übung nicht in deinem Plan gefunden.`)
};

const it_it2_plan_item_not_found = /** @type {(inputs: Plan_Item_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non abbiamo trovato quell'esercizio nella tua scheda.`)
};

/**
* | output |
* | --- |
* | "We could not find that exercise in your plan." |
*
* @param {Plan_Item_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_item_not_found = /** @type {((inputs?: Plan_Item_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Item_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_item_not_found(inputs)
	if (locale === "es-419") return es_419_plan_item_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_item_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_item_not_found(inputs)
	if (locale === "de-DE") return de_de2_plan_item_not_found(inputs)
	if (locale === "it-IT") return it_it2_plan_item_not_found(inputs)
	return en_us2_plan_item_not_found(inputs)
});
export { plan_item_not_found as "plan.item_not_found" }